
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"388","width":"402","preserveAspectRatio":"none","viewBox":"0 0 390 368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.16 54.822C21.884 61.14 19.837 63.177 0 66.932V388h402V0c-11.91 2.668-38.742 10.534-65.157 25.536-33.424 18.98-94.876 57.218-171.698 29.286-63.075-22.934-96.144-14.113-132.986 0z","fill":"#00ada8"}})])
          )
        }
      }
    